export const handleTimestamp = (timestamp: string) => {
  const handledTimestamp = new Date(timestamp).toLocaleString('ru-RU');

  return handledTimestamp
    .replace(',', '')
    .substring(0, handledTimestamp.length - 4);
};
